import { render, staticRenderFns } from "./StaffDetailByIdCardModal.vue?vue&type=template&id=467195b3&scoped=true&"
import script from "./StaffDetailByIdCardModal.vue?vue&type=script&lang=js&"
export * from "./StaffDetailByIdCardModal.vue?vue&type=script&lang=js&"
import style0 from "./StaffDetailByIdCardModal.vue?vue&type=style&index=0&id=467195b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467195b3",
  null
  
)

export default component.exports